import * as actions from './actions'
import Fuse from 'fuse.js'

const initState = {
    detachedSharingData: null,
    detachedSharingDataFused: null,
    isDetachedSharingLoading: false,
    sharedUsers: null
}

export default function reducer(state = initState, action) {
    switch(action.type) {
        case actions.DETACHED_SHARING_DATA_SUCCESS:
            return {
                ...state,
                ...{
                    detachedSharingData: action.detachedSharingData,
                    detachedSharingDataFused: new Fuse(
                        action.detachedSharingData || [],
                        {
                            keys: ['name', 'devices.name', 'devices.serial_number']
                        }
                    )
                }
            }
        case actions.SET_DETACHED_SHARING_DATA:
            return {
                ...state,
                ...{
                    detachedSharingData: action.detachedSharingData
                }
            }
        case actions.START_DETACHED_SHARING_LOADING:
            return {
                ...state,
                ...{
                    isDetachedSharingLoading: true
                }
            }
        case actions.STOP_DETACHED_SHARING_LOADING:
            return {
                ...state,
                ...{
                    isDetachedSharingLoading: false
                }
            }
        case actions.SHARED_USERS_SUCCESS:
            return {
                ...state,
                ...{
                    sharedUsers: action.sharedUsers
                }
            }
        default:
            return state
    }
}